/* eslint-disable array-callback-return */
import React from 'react';
import PlayerCard from './PlayerCard';

const sortByProperty = (property) => {  
    return function(a,b){  
        if(a[property] > b[property])  
            return 1;  
        else if(a[property] < b[property])  
            return -1;  
    
        return 0;  
    }  
}

const OtherTeams = (props) => {
  ///check cookie for user name / email
  // match against the db.users to find the user id for the room
  // db.players where their team equals users team id
    const myTeam = Number(props.myTeam);
    const currentPick = props.currentPick;
    const players = props.players;
    const isAdmin = props.isAdmin;
    const isMyTurn = props.isMyTurn;
    const otherTeams = props.users.filter(x => x.team !== myTeam);
    const otherTeamPlayers = players.filter(x => x.team !== 0 && x.team !== myTeam);
    otherTeamPlayers.sort(sortByProperty('pick'))

    const otherTeamList = otherTeams.map((user, index) => {
        var teamKey = user.team;
        var myPlayers = players.filter(x => x.team === user.team);
        return (
            <div key={teamKey+`_`+index} className="team-box" data-teambox={user.name}>
                <div className="team-interior">
                    <h3 className="team-header">{user.name}</h3>
                    <ol key={teamKey+`-`+index} id={'team' + teamKey} data-key={teamKey+`-`+index} className={'team-list team' + teamKey}>
                        { 
                            myPlayers.map(player => {
                                return  (
                                    <PlayerCard key={player.pid+'_otherTeams'} player={player} currentPick={currentPick} isAdmin={isAdmin} myTeam={myTeam} isMyTurn={isMyTurn} />
                                )
                            })
                            
                        }
                    </ol>
                </div>
            </div>
        )
    })

    return  (
        <div id="other-teams">
            {otherTeamList}
        </div>
    )
};

export default OtherTeams;